var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.141,
    height: 123.451,
    viewBox: "0 0 76.141 123.451",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1205",
    "data-name": "Group 1205",
    transform: "translate(23366.906 -18545.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M-219.216,986.842q-6.669-8.038-6.669-17.087a23.064,23.064,0,0,1,9.184-18.9q9.181-7.308,23.7-7.307,14.981,0,24.982,8.129t10,20.276a26.269,26.269,0,0,1-4.2,14.843q-4.2,6.347-14.341,13.2l-9.683,6.487a33.942,33.942,0,0,0-8.45,8.267q-3.7,5.069-3.517,8.176l.274,5.024a2.968,2.968,0,0,1-.822,2.284,2.558,2.558,0,0,1-2.193.822q-2.1-.092-3.745-3.014a13.367,13.367,0,0,1-1.643-6.669q0-12.514,13.883-26.672,9.136-9.318,12.286-14.707a22.924,22.924,0,0,0,3.152-11.784,17.46,17.46,0,0,0-4.561-12.56,15.88,15.88,0,0,0-12.057-4.8,16.017,16.017,0,0,0-10.87,3.974,12.235,12.235,0,0,0-4.567,9.546q0,5.932,7.49,10.413-.822.548-.914.64l-4.937,2.831A77.323,77.323,0,0,0-219.216,986.842Z",
    transform: "translate(-23140.516 17602.455)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M-168.807,948.083q13.427,9.868,13.427,25.124a30.52,30.52,0,0,1-6.577,18.817q-3.38,4.471-19.547,16.441l-5.115,3.745q-9.318,6.942-9.317,13.155a15.6,15.6,0,0,0,2.467,7.49l-3.288-.914a14.219,14.219,0,0,1-1.645-6.577,13.672,13.672,0,0,1,3.288-8.86q3.287-4.019,11.968-10.047,14.707-10.049,20.187-17.4a27.593,27.593,0,0,0,5.481-16.945,28.464,28.464,0,0,0-3.243-13.29A25.331,25.331,0,0,0-169.444,949Z",
    transform: "translate(-23135.387 17603.303)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M-191.984,974.531l-2.01,1.1a215.518,215.518,0,0,0-20.37,12.967l-.822.548-1.458-1.915.914-.64a186.188,186.188,0,0,1,19-12.057q-7.49-4.747-7.49-12.331a8.086,8.086,0,0,1,3.014-6.348,11.048,11.048,0,0,1,7.49-2.6q8.677,0,12.971,9.865h-.547q-5.576-7.4-12.7-7.4-7.855,0-7.855,7.034Q-201.85,970.324-191.984,974.531Z",
    transform: "translate(-23138.791 17604.264)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M-195.934,1020.983a11.852,11.852,0,0,1,11.875,11.828v.051a11.851,11.851,0,0,1-11.875,11.784,11.341,11.341,0,0,1-8.312-3.471,11.343,11.343,0,0,1-3.471-8.312,11.443,11.443,0,0,1,3.471-8.4A11.339,11.339,0,0,1-195.934,1020.983Z",
    transform: "translate(-23137.125 17616.904)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M-181.749,1024.216a15.15,15.15,0,0,1,5.115,11.693,14.969,14.969,0,0,1-4.613,10.87,14.753,14.753,0,0,1-10.824,4.659,14.732,14.732,0,0,1-11.874-5.477l.548-.64a21.318,21.318,0,0,0,10.688,3.471,13.583,13.583,0,0,0,9.773-3.968,12.7,12.7,0,0,0,4.11-9.455,18.744,18.744,0,0,0-3.654-10.5Z",
    transform: "translate(-23136.422 17617.508)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionsIcon);
export default __webpack_public_path__ + "static/media/questions-icon.0547b96649a19057d8c9172c6b6da484.svg";
export { ForwardRef as ReactComponent };